import { connect } from 'react-redux'
import { authenticate } from 'redux/modules/auth'

import SigninComponent from '../components/SigninComponent'

const mapActionCreators = {
  authenticate
}

const mapStateToProps = state => ({
  auth: state.auth
})

export default connect(mapStateToProps, mapActionCreators)(SigninComponent)



// WEBPACK FOOTER //
// ./src/routes/Signin/containers/SigninContainer.js